import { z } from 'zod';

export const MarginProfileSchema = z.object({
  id: z.string().uuid(),
  name: z.string(),
  material_margin: z.number().default(0),
  framing_material_margin: z.number().default(0),
  finish_material_margin: z.number().default(0),
  hardware_margin: z.number().default(0),
  labor_margin: z.number().default(0),
  finish_margin: z.number().default(0),
  overall_margin: z.number().default(0),
  cnc_margin: z.number().default(0.15),
  notes: z.string().nullable(),
  active: z.boolean().default(true),
  created_at: z.string().datetime(),
  updated_at: z.string().datetime(),
});

export const CreateMarginProfileSchema = z.object({
  name: z.string().min(1, 'Name is required'),
  material_margin: z.number().default(0),
  framing_material_margin: z.number().default(0),
  finish_material_margin: z.number().default(0),
  hardware_margin: z.number().default(0),
  labor_margin: z.number().default(0),
  finish_margin: z.number().default(0),
  overall_margin: z.number().default(0),
  cnc_margin: z.number().default(0.15),
  notes: z.string().nullable().optional(),
  active: z.boolean().default(true),
});

export const UpdateMarginProfileSchema = CreateMarginProfileSchema.partial();

export type MarginProfile = z.infer<typeof MarginProfileSchema>;
export type CreateMarginProfile = z.infer<typeof CreateMarginProfileSchema>;
export type UpdateMarginProfile = z.infer<typeof UpdateMarginProfileSchema>;
